"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadingStore = void 0;
const vue_1 = require("vue");
const pinia_1 = require("pinia");
exports.useLoadingStore = (0, pinia_1.defineStore)('loading', () => {
    const loading = (0, vue_1.ref)(false);
    return { loading };
});
